import { EEnvironment, TEnvironmentalVariables } from '~/constants/environment';

const USERCENTRICS_CLIENT_ID = 'QokmUou20';

export function initUserCentrics(): void {
  const UCScript = document.createElement('script');
  UCScript.setAttribute('id', 'usercentrics-cmp');
  UCScript.setAttribute(
    'src',
    'https://app.usercentrics.eu/browser-ui/latest/loader.js',
  );
  UCScript.setAttribute('async', '');
  UCScript.setAttribute('data-settings-id', USERCENTRICS_CLIENT_ID);

  const { REACT_APP_ENVIRONMENT: environment } =
    process.env as TEnvironmentalVariables;

  // use draft version of CMP config
  if (
    environment !== EEnvironment.PRODUCTION &&
    environment !== EEnvironment.QA
  ) {
    UCScript.setAttribute('data-version', 'preview');
  }

  // don't collect analytics on locally run dev server
  if (!environment) {
    UCScript.setAttribute('data-disable-tracking', '');
  }

  document.head.appendChild(UCScript);
}
